<div *ngIf="isVisible" class="modal-overlay">
  <div class="modal-content">
    <div *ngIf="deviceInfo">
      <h3 class="header">Device</h3>

      <div class="device-info">
        <span *ngIf="deviceInfo.manufacturer">Make: {{ deviceInfo.manufacturer }}</span>
        <span *ngIf="deviceInfo.manufacturer && deviceInfo.model" class="separator">|</span>
        <span *ngIf="deviceInfo.model">Model: {{ deviceInfo.model }}</span>
        <span *ngIf="deviceInfo.model && deviceInfo.osVersion" class="separator">|</span>
        <span *ngIf="deviceInfo.osVersion">OS Version: {{ deviceInfo.osVersion }}</span>
      </div>
      
    </div>

    <div *ngIf="permissions && permissions.length > 0">
      <h3 class="header">Permissions</h3>
      <ul>
        <li *ngFor="let permission of permissions" class="permission-item">
          <span *ngIf="permission.granted" class="icon-tick">&#10004;</span> <!-- Checkmark -->
          <span *ngIf="!permission.granted" class="icon-cross">&#10008;</span> <!-- Cross -->

          <span>{{ permission.name }}</span>
        </li>
      </ul>
      <div class="footer">
        <span class="date">Permissions updated on: {{ formattedDate }}</span>
      </div>
    </div>

    <button (click)="closePopup()">Close</button>
  </div>
</div>